
export default [
  //\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
  //\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
  //                                                  APPS
  //\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/

  {
    url: "/apps/",
    name: "apps",
    title: "Squeak apps",
    subpages: {

      //
      //                              ALL

      "": [

        // DATO
        "dato",

        // GRAPHER
        "grapher",

        // SQUIK
        {
          name: "squik",
          absolutePath: "__REPLACED_BY_CURRENT_APP_PATH__",
        },

      ],

      //                              ¬
      //

    },
  },

  //\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
  //\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
  //                                                  LIBRARIES
  //\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/

  {
    url: "/libs/",
    name: "libraries",
    title: "Squeak libraries",
    subpages: {

      //
      //                              SYNTAX

      "": [
        "squyntax",
      ],

      //
      //                              ELECTRODE FRAMEWORK

      "electrode framework": [
        "electrode",
        "stylectrode",
      ],

      //
      //                              GENERAL UTILITIES LIBRARIES

      "general utilities libraries": [
        "squeak",
        "yquerj",
        "demeter",
        "markdownify",
      ],

      //
      //                              UI LIBRARIES

      "UI/UX libraries": [
        "uify",
        "keyboardify",
        "toolbarify",
        "windify",
        "inputify",
        "dialogify",
        "postify",
        "viewify",
        "graphify",
        "tablify",
      ],

      //
      //                              OTHER LIBRARIES

      "other libraries": [
        "squid",
        "maghost",
      ],

      //
      //                              DATO LIBRARIES

      "dato libraries": [
        "dantheon",
      ],

      //                              ¬
      //

    },
  },

  //\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
  //\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/\/
];
